import { Facebook } from "lucide-react";

/**
 * Bouton de partage Facebook — ouvre le sharer FB officiel dans une popup centrée.
 * Idéal pour les stories : les utilisateurs peuvent partager la page en 1 clic.
 *
 * Props :
 *  - url       : URL absolue à partager (défaut = window.location.href)
 *  - label     : texte visible (défaut = "Partager sur Facebook")
 *  - variant   : "solid" (fond bleu FB), "outline" (contour bleu), "icon" (rond icône seule)
 *  - testid    : data-testid custom
 */
export default function FacebookShareButton({ url, label = "Partager sur Facebook", variant = "solid", testid = "facebook-share", className = "" }) {
  const href = url || (typeof window !== "undefined" ? window.location.href : "");

  const open = (e) => {
    e.preventDefault();
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(href)}`;
    const w = 626, h = 436;
    const left = typeof window !== "undefined" ? (window.innerWidth - w) / 2 : 0;
    const top = typeof window !== "undefined" ? (window.innerHeight - h) / 2 : 0;
    window.open(shareUrl, "fb-share", `width=${w},height=${h},left=${left},top=${top},noopener,noreferrer`);
  };

  const styles = {
    solid: "bg-[#1877F2] text-white hover:bg-[#0f5fc9] shadow-[0_6px_20px_-4px_rgba(24,119,242,0.55)]",
    outline: "border border-[#1877F2]/60 text-[#1877F2] hover:bg-[#1877F2] hover:text-white",
    icon: "w-12 h-12 rounded-full bg-[#1877F2] text-white hover:bg-[#0f5fc9] flex items-center justify-center shadow-[0_6px_20px_-4px_rgba(24,119,242,0.55)]",
    "icon-prestige": "w-11 h-11 rounded-full bg-black/60 backdrop-blur-md border border-[#C8A75A]/60 text-[#C8A75A] hover:bg-[#C8A75A] hover:text-black hover:border-[#C8A75A] flex items-center justify-center shadow-[0_6px_20px_-4px_rgba(0,0,0,0.6)]",
  };

  if (variant === "icon" || variant === "icon-prestige") {
    return (
      <button
        type="button"
        onClick={open}
        data-testid={testid}
        aria-label={label}
        title={label}
        className={`${styles[variant]} transition-all duration-300 ${className}`}
      >
        <Facebook className="w-4 h-4" fill="currentColor" strokeWidth={0} />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={open}
      data-testid={testid}
      aria-label={label}
      className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-[11px] uppercase tracking-widest font-semibold transition-colors ${styles[variant]} ${className}`}
    >
      <Facebook className="w-4 h-4" fill="currentColor" strokeWidth={0} />
      <span>{label}</span>
    </button>
  );
}
